import { THideSocials } from '@/utils'

export const DEFAULT_HIDE_SOCIALS: THideSocials = {
	FACEBOOK: false,
	GOOGLE: false,
	APPLE: false,
}

export const hasVisibleSocialAuth = (hideSocials: THideSocials) =>
	!hideSocials.FACEBOOK || !hideSocials.GOOGLE || !hideSocials.APPLE

export const hasHiddenSocial = (hideSocials: THideSocials) =>
	hideSocials.FACEBOOK || hideSocials.GOOGLE || hideSocials.APPLE
